var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddFriendInline = function SvgIconAddFriendInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-add-friend",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-add",
    transform: "translate(-347.172 -219.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M362.172 242.6a1 1 0 0 1-1-1v-1.625c0-2.413-2.691-4.375-6-4.375s-6 1.962-6 4.375v1.625a1 1 0 1 1-2 0v-1.625c0-3.516 3.589-6.375 8-6.375s8 2.859 8 6.375v1.625a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M355.172 231.6a5.5 5.5 0 1 1 5.5-5.5 5.507 5.507 0 0 1-5.5 5.5Zm0-9a3.5 3.5 0 1 0 3.5 3.5 3.5 3.5 0 0 0-3.5-3.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M367.172 235.6a1 1 0 0 1-1-1v-6a1 1 0 0 1 2 0v6a1 1 0 0 1-1 1Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M370.172 232.6h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2Z",
    fill: "currentColor"
  })))));
};
export { SvgIconAddFriendInline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1hZGQtZnJpZW5kIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxyZWN0IGlkPSJhcmVhIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiLz4KICAgIDxnIGlkPSJ1c2VyLWFkZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTM0Ny4xNzIgLTIxOS42KSI+CiAgICAgICAgPGcgaWQ9Ikdyb3VwXzQ2IiBkYXRhLW5hbWU9Ikdyb3VwIDQ2Ij4KICAgICAgICAgICAgPHBhdGggaWQ9IlBhdGhfMTU3IiBkYXRhLW5hbWU9IlBhdGggMTU3IgogICAgICAgICAgICAgICAgICBkPSJNMzYyLjE3MiwyNDIuNmExLDEsMCwwLDEtMS0xdi0xLjYyNWMwLTIuNDEzLTIuNjkxLTQuMzc1LTYtNC4zNzVzLTYsMS45NjItNiw0LjM3NVYyNDEuNmExLDEsMCwxLDEtMiwwdi0xLjYyNWMwLTMuNTE2LDMuNTg5LTYuMzc1LDgtNi4zNzVzOCwyLjg1OSw4LDYuMzc1VjI0MS42QTEsMSwwLDAsMSwzNjIuMTcyLDI0Mi42WiIKICAgICAgICAgICAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIGlkPSJHcm91cF80NyIgZGF0YS1uYW1lPSJHcm91cCA0NyI+CiAgICAgICAgICAgIDxwYXRoIGlkPSJQYXRoXzE1OCIgZGF0YS1uYW1lPSJQYXRoIDE1OCIKICAgICAgICAgICAgICAgICAgZD0iTTM1NS4xNzIsMjMxLjZhNS41LDUuNSwwLDEsMSw1LjUtNS41QTUuNTA3LDUuNTA3LDAsMCwxLDM1NS4xNzIsMjMxLjZabTAtOWEzLjUsMy41LDAsMSwwLDMuNSwzLjVBMy41LDMuNSwwLDAsMCwzNTUuMTcyLDIyMi42WiIKICAgICAgICAgICAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIGlkPSJHcm91cF80OCIgZGF0YS1uYW1lPSJHcm91cCA0OCI+CiAgICAgICAgICAgIDxwYXRoIGlkPSJQYXRoXzE1OSIgZGF0YS1uYW1lPSJQYXRoIDE1OSIKICAgICAgICAgICAgICAgICAgZD0iTTM2Ny4xNzIsMjM1LjZhMSwxLDAsMCwxLTEtMXYtNmExLDEsMCwwLDEsMiwwdjZBMSwxLDAsMCwxLDM2Ny4xNzIsMjM1LjZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgICAgICA8L2c+CiAgICAgICAgPGcgaWQ9Ikdyb3VwXzQ5IiBkYXRhLW5hbWU9Ikdyb3VwIDQ5Ij4KICAgICAgICAgICAgPHBhdGggaWQ9IlBhdGhfMTYwIiBkYXRhLW5hbWU9IlBhdGggMTYwIiBkPSJNMzcwLjE3MiwyMzIuNmgtNmExLDEsMCwwLDEsMC0yaDZhMSwxLDAsMCwxLDAsMloiCiAgICAgICAgICAgICAgICAgIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";